import { Box, Grid, GridItem, Skeleton, VStack } from '@chakra-ui/react';
import { AuthedPageContainer } from '@/components';
import { LeaderboardSkeletonRow } from './LeaderboardSkeletonRow';
import { LeaguePageLayout } from './LeaguePageLayout';

const SKELETON_ROW_COUNT = 8;

export function LeaguePageSkeleton(props: { isGlobalLeague?: boolean }) {
  const { isGlobalLeague = false } = props;

  return (
    <AuthedPageContainer>
      <LeaguePageLayout>
        <VStack align='stretch' spacing={2} w='full'>
          <Skeleton h='8' maxW='16rem' borderRadius='md' />
          <Skeleton h='4' maxW='10rem' borderRadius='sm' />
        </VStack>

        <Grid
          templateColumns={{ base: '1fr', lg: isGlobalLeague ? '1fr' : '1fr 280px' }}
          gap={4}
          w='full'
          alignItems='start'
          mt={4}
        >
          <GridItem minW={0}>
            <Box borderRadius='md' p={4} bg='listItemBackground'>
              <Skeleton h='5' w='24' mb={3} borderRadius='sm' />
              <VStack align='stretch' spacing={1}>
                {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => (
                  <LeaderboardSkeletonRow key={i} />
                ))}
              </VStack>
            </Box>
          </GridItem>
          {!isGlobalLeague ? (
            <GridItem minW={0}>
              <Skeleton h='32' borderRadius='md' />
            </GridItem>
          ) : null}
        </Grid>
      </LeaguePageLayout>
    </AuthedPageContainer>
  );
}
